import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { UserState } from '@hiptraveler/data-access/user';
import { ItineraryState } from '@hiptraveler/data-access/itinerary';
import { AuthDialogActionService } from '@hiptraveler/dialogs/auth-dialog';
import { PromptDialogActionService, PromptDialogButton } from '@hiptraveler/dialogs/prompt-dialog';
import { addItineraryRequestPending, AppListenerService, currentLang, getWindowRef, NavbarButtonData, NavbarControlStateService, ofActionDispatchedSignOutNoAuthState, siteNavigationCloseActionKey } from '@hiptraveler/common';
import { CommonService } from './common.service';

@Injectable()
export class CloseOpenTripButtonObserverService {

  openTripButton: NavbarButtonData;

  constructor(
    private router: Router,
    private store: Store,
    private appListener: AppListenerService,
    private navbarControl: NavbarControlStateService,
    private authDialog: AuthDialogActionService,
    private promptDialog: PromptDialogActionService,
    private commonService: CommonService
  ) { }

  observe(): void {
    this.appListener.globalSignalListener(siteNavigationCloseActionKey).subscribe(() => {

      const authenticated = this.store.selectSnapshot(UserState.authenticated);
      const buttons = this.navbarControl.activeNavbarActionButtons$$.value;
      const openTripButton = buttons?.find(e => e?.name?.includes('navbar.action-text-open-trip'));
      const hasOpenTripButton = !!openTripButton;
      const viewOrComposePage = new RegExp(`/${currentLang()}/(itinerary|compose)/`).test(this.router.url);
      
      if (viewOrComposePage || !hasOpenTripButton) return;

      if (openTripButton) {
        this.openTripButton = openTripButton;
      }

      authenticated
        ? this.commonService.removeOpenTripProcess()
        : this.openSaveTripPromptDialog();

    });
  }

  private openSaveTripPromptDialog(): void {

    if (!this.store.selectSnapshot(ItineraryState.basicInfo)) return;
    if (getWindowRef()?.[addItineraryRequestPending] || getWindowRef()?.[ofActionDispatchedSignOutNoAuthState]) return;

    const loginOrRegisterButton: PromptDialogButton = {
      name: 'exp-finder.log-in-register',
      theme: 'primary',
      progressSpinner: true,
      executable: () => {
        this.authDialog.open();
        ref.close();
      }
    };

    const closeButton: PromptDialogButton = {
      name: 'exp-finder.close',
      theme: 'secondary',
      progressSpinner: true,
      executable: () => {
        this.commonService.removeOpenTripProcess();
        ref.close(true);
      }
    };

    const ref: any = this.promptDialog.open({
      title: 'exp-finder.save-your-trip',
      message: 'exp-finder.create-a-profile-to-save-your-trip',
      buttons: [ loginOrRegisterButton, closeButton ]
    });

    ref?.afterClosed().subscribe((res: any) => {
      if (res) return;
      this.navbarControl.setActiveNavbarButtons([ this.openTripButton ]);
    });
  }

}
